export default __webpack_public_path__ + "static/media/VISIONSGS-logo.1953ab71.png";